"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectConnector = void 0;
const protocol_1 = require("../protocol");
const utils_1 = require("../utils");
const iconnector_1 = require("./iconnector");
const SolProvider_1 = require("../inject/provider/SolProvider");
const wallet_info_1 = require("../protocol/connect/wallet-info");
const AptosProvider_1 = require("../inject/provider/AptosProvider");
const media_1 = require("../utils/media");
const TONProvider_1 = require("../inject/provider/TONProvider");
const inject_1 = require("../inject");
const sui_provider_1 = require("../inject/provider/sui-provider");
const utils_2 = require("../utils/utils");
const sessionUtils_1 = require("../connect/sessionUtils");
class InjectConnector {
    constructor() {
        this.disconnectListener = [];
        this.providerMap = new Map();
        this.accountChangedEVMHandler = null;
        this.accountChangedSolanaPublicKeyHandler = null;
        this.accountChangedTONHandler = null;
        this.disconnectHandler = null;
        this.walletName = "";
        this.walletNameKey = '';
        this.enable = true;
        this.providerMap.set(protocol_1.NameSpaceKeyEip155, new inject_1.Eip155Provider());
        this.providerMap.set(protocol_1.NameSpaceKeySOL, new SolProvider_1.SolProvider());
        this.providerMap.set(protocol_1.NameSpaceKeyAptos, new AptosProvider_1.AptosProvider());
        this.providerMap.set(protocol_1.NameSpaceKeyTON, new TONProvider_1.TONProvider());
        this.providerMap.set(protocol_1.NameSpaceKeySui, new sui_provider_1.SuiProvider());
    }
    setAccountChangeListener(accountChangeListener) {
        (0, utils_1.logDebug)("setAccountChangeListener: inject", accountChangeListener);
        this.accountChangeListener = accountChangeListener;
    }
    setConnectionManager(connectionManager) {
        this.connectionManager = connectionManager;
    }
    getInjectProvider(nameSpace) {
        for (const [mapKey, value] of this.providerMap.entries()) {
            if (nameSpace.includes(mapKey)) {
                return value;
            }
        }
        return undefined;
    }
    openWallet(engineConnectInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            (0, utils_1.logDebug)("InjectEngine connect begin:", JSON.stringify(engineConnectInfo));
            if (!engineConnectInfo) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR);
            }
            this.dappInfo = engineConnectInfo.connectRequest.dAppInfo;
            var universalConnectRequest = engineConnectInfo.connectRequest;
            try {
                if (window && window.okxwallet) {
                    if (universalConnectRequest.requests) {
                        let requestAccounts = universalConnectRequest.requests
                            .find(item => item.name === "requestAccounts");
                        let version = yield window.okxwallet.getVersion();
                        let result = {
                            method: "connect",
                            requestId: universalConnectRequest.requestId,
                            payload: {
                                wallet: {
                                    platform: (_a = navigator.platform) !== null && _a !== void 0 ? _a : "/",
                                    appName: wallet_info_1.OKXInjectWalletName,
                                    appVersion: version !== null && version !== void 0 ? version : "1.0.0",
                                    maxProtocolVersion: 1,
                                },
                                responses: []
                            },
                        };
                        let responseItem = {
                            name: "requestAccounts",
                            accounts: [],
                        };
                        result.payload.responses.push(responseItem);
                        yield this.disconnect();
                        const required = (_b = requestAccounts.requiredNamespaces) !== null && _b !== void 0 ? _b : [];
                        const optional = (_c = requestAccounts.optionalNamespaces) !== null && _c !== void 0 ? _c : [];
                        let needPop = true;
                        let signalChain = false;
                        if (required.length + optional.length === 1 && !(0, media_1.isDevice)("mobile")) {
                            const singleItem = required.length === 1 ? required[0] : optional[0];
                            const singleProvider = this.getInjectProvider(singleItem.namespace);
                            yield (singleProvider === null || singleProvider === void 0 ? void 0 : singleProvider.connect(singleItem, this.dappInfo));
                            signalChain = true;
                            needPop = false;
                        }
                        var accounts = yield this.getAccountByRequestWallets(needPop, false, signalChain, required, optional);
                        if (accounts) {
                            responseItem.accounts.push(...accounts);
                            if (responseItem.accounts.length === 0) {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "connect connectAccounts is null");
                            }
                        }
                        else {
                            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "connect requestWallets is null");
                        }
                        if (this.connectResultListener) {
                            if (this.disconnectHandler) {
                                window.okxwallet.removeListener('disconnect', this.disconnectHandler);
                            }
                            this.disconnectHandler = () => {
                                console.log("window.okxwallet disconnect:");
                                this.disconnectListener.forEach(listener => listener());
                                this.disconnectListener = [];
                            };
                            window.okxwallet.on('disconnect', this.disconnectHandler);
                            this.connectResultListener(result);
                        }
                    }
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR);
                }
            }
            catch (error) {
                var code = protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR;
                var message = '';
                if (error instanceof protocol_1.OKXConnectError) {
                    code = error.code;
                    message = error.message;
                }
                if (this.connectResultListener) {
                    this.connectResultListener({
                        requestId: "-1",
                        method: 'connect_error',
                        payload: {
                            code: code
                        }
                    });
                }
            }
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, utils_1.logDebug)('InjectEngine ==>> disconnect  okxwallet.disconnect()');
            if (window.okxwallet) {
                yield window.okxwallet.disconnect();
                (0, utils_1.logDebug)('InjectEngine ==>> disconnect end okxwallet.disconnect()');
            }
        });
    }
    getRequestId() {
        const requestId = Date.now().toString();
        (0, utils_1.logDebug)('InjectEngine ==>> getRequestId ==>', requestId);
        return requestId;
    }
    send(request, requestAnswer) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                (0, utils_1.logDebug)("InjectEngine send  > request:", (0, utils_1.safeJsonStringify)(request));
                let newRequest = request;
                if (newRequest.method === 'disconnect') {
                    yield this.disconnect();
                    this.disconnectListener.forEach(listener => listener());
                    this.disconnectListener = [];
                    (_a = requestAnswer.onAck) === null || _a === void 0 ? void 0 : _a.call(requestAnswer);
                    return;
                }
                yield this.checkWalletMatch();
                const injectProvider = this.getInjectProvider(newRequest.chainId);
                if (injectProvider) {
                    injectProvider.send(newRequest).then(result => {
                        var _a;
                        (0, utils_1.logDebug)("InjectEngine ==>> send > result:", result);
                        (_a = requestAnswer.resolve) === null || _a === void 0 ? void 0 : _a.call(requestAnswer, result);
                    }).catch(error => {
                        var _a;
                        let code = error.code;
                        if (code === 4001) {
                            code = protocol_1.OKX_CONNECT_ERROR_CODES.USER_REJECTS_ERROR;
                        }
                        let errorResponse = {
                            requestId: this.getRequestId(),
                            method: request.method,
                            error: {
                                code: code,
                                message: error.message
                            }
                        };
                        (0, utils_1.logDebug)("InjectEngine ==>> send > errorResponse:", JSON.stringify(errorResponse));
                        (_a = requestAnswer.resolve) === null || _a === void 0 ? void 0 : _a.call(requestAnswer, errorResponse);
                    });
                    return;
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("InjectEngine ==>> send  ===> error:", error);
                return Promise.reject(error);
            }
        });
    }
    checkWalletMatch() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                let sessionLocal = (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.getSessionContent('connectSession');
                if (!sessionLocal) {
                    reject(new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED));
                }
                this.restoreconnect(sessionLocal, (session) => {
                    if (session) {
                        resolve();
                    }
                    else {
                        reject(new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED));
                    }
                });
            });
        });
    }
    checkAccountChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                let sessionLocal = (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.getSessionContent('connectSession');
                if (!sessionLocal) {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
                }
                (0, utils_1.logDebug)("inject-connector checkAccountChanged --sessionInfo:", JSON.stringify(sessionLocal));
                let requiredNamespaces = this.getRequireNameSpaceFromSession(sessionLocal);
                (0, utils_1.logDebug)("inject-connector checkAccountChanged --requiredNamespaces:", JSON.stringify(requiredNamespaces));
                // 使用 await 等待异步操作完成
                let accounts = yield this.getAccountByRequestWallets(false, true, false, requiredNamespaces, []);
                (0, utils_1.logDebug)("inject-connector checkAccountChanged --accounts:", JSON.stringify(accounts));
                if (accounts) {
                    let resultNameSpace = {};
                    (0, sessionUtils_1.buildAccountNameSpaces)(accounts, resultNameSpace);
                    if (!this.compareAndModifyNamespaces(sessionLocal.namespaces, resultNameSpace)) {
                        (0, utils_1.logDebug)("inject-connector checkAccountChanged --result sessionLocal:", JSON.stringify(sessionLocal));
                        if (this.accountChangeListener) {
                            (0, utils_1.logDebug)("inject-connector checkAccountChanged -accountChangeListener:", this.accountChangeListener);
                            this.accountChangeListener(sessionLocal);
                        }
                        else {
                            (0, utils_1.logDebug)("inject-connector checkAccountChanged disconnect:");
                            yield this.disconnect();
                        }
                    }
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "connect requestWallets is null");
                }
            }
            catch (e) {
                (0, utils_1.logDebug)("inject-connector restoreconnect catch error", JSON.stringify(e));
                throw e;
            }
        });
    }
    compareAndModifyNamespaces(nameSpaces1, nameSpaces2) {
        let isAccountsSame = true;
        for (const key in nameSpaces1) {
            if (nameSpaces2[key]) {
                const ns1 = nameSpaces1[key];
                const ns2 = nameSpaces2[key];
                (0, utils_1.logDebug)("inject-connector checkAccountChanged ns1:", JSON.stringify(ns1));
                (0, utils_1.logDebug)("inject-connector checkAccountChanged ns2:", JSON.stringify(ns2));
                const areAccountsSame = JSON.stringify([...ns1.accounts].sort()) === JSON.stringify([...ns2.accounts].sort());
                if (!areAccountsSame) {
                    isAccountsSame = false;
                    ns1.accounts = [...ns2.accounts];
                    ns1.extra = Object.assign({}, ns2.extra);
                    ns1.payload = Object.assign({}, ns2.payload);
                }
                (0, utils_1.logDebug)("inject-connector checkAccountChanged new ns1:", JSON.stringify(ns1));
            }
        }
        (0, utils_1.logDebug)(`inject-connector checkAccountChanged compareAndModifyNamespaces ===> ${isAccountsSame}`);
        return isAccountsSame;
    }
    clearData() {
        this.connectResultListener = undefined;
    }
    addDisconnectListener(disconnecter) {
        this.disconnectListener.push(disconnecter);
    }
    setOnConnectResultListener(connectResultListener) {
        this.connectResultListener = connectResultListener;
    }
    connectManagerDisconnect() {
        return __awaiter(this, arguments, void 0, function* (_ = false) {
        });
    }
    getCurrentConnectionReady(namespaceKeys) {
        if (!namespaceKeys) {
            return false;
        }
        const allReady = namespaceKeys.every(namespaceKey => { var _a; return (_a = this.getInjectProvider(namespaceKey)) === null || _a === void 0 ? void 0 : _a.connectReady(); });
        return allReady;
    }
    getTag() {
        return iconnector_1.OKX_INJECT_WALLET;
    }
    toJSON() {
        return "inject-connector";
    }
    getRequireNameSpaceFromSession(sessionInfo) {
        var _a, _b;
        var requiredNamespaces = [];
        for (let namespacesKey in sessionInfo.namespaces) {
            let nameSpace = sessionInfo.namespaces[namespacesKey];
            let connectWalletNameSpace = {
                namespace: namespacesKey,
                chains: nameSpace.chains
            };
            if (namespacesKey === protocol_1.NameSpaceKeyAptos) {
                let aptosChains = [];
                nameSpace.chains.forEach((chainStr) => {
                    let aptosChain = (0, utils_2.replaceChainNameToChainId)(chainStr);
                    aptosChains.push(aptosChain);
                });
                connectWalletNameSpace = {
                    namespace: namespacesKey,
                    chains: aptosChains
                };
            }
            else if (namespacesKey === protocol_1.NameSpaceKeyTON) {
                let ton_proof_result_Item = undefined;
                let proofItem = undefined;
                if ((_a = nameSpace.payload) === null || _a === void 0 ? void 0 : _a.ton_proof) {
                    ton_proof_result_Item = (_b = nameSpace.payload) === null || _b === void 0 ? void 0 : _b.ton_proof;
                    if (ton_proof_result_Item.proof.payload) {
                        proofItem = {
                            name: "ton_proof",
                            payload: ton_proof_result_Item.proof.payload
                        };
                    }
                }
                connectWalletNameSpace = {
                    namespace: namespacesKey,
                    chains: nameSpace.chains,
                    params: {
                        ton_addr: { name: 'ton_addr' },
                        ton_proof: proofItem
                    },
                };
            }
            requiredNamespaces.push(connectWalletNameSpace);
        }
        return requiredNamespaces;
    }
    restoreconnect(sessionInfo, onConnectResult) {
        var _a;
        if (!window.okxwallet) {
            onConnectResult(null);
            return;
        }
        this.dappInfo = (_a = sessionInfo.sessionConfig) === null || _a === void 0 ? void 0 : _a.dappInfo;
        (0, utils_1.logDebug)("inject-connector restoreconnect --sessionInfo:", JSON.stringify(sessionInfo));
        var requiredNamespaces = this.getRequireNameSpaceFromSession(sessionInfo);
        (0, utils_1.logDebug)("inject-connector restoreconnect --requiredNamespaces:", JSON.stringify(requiredNamespaces));
        this.getAccountByRequestWallets(false, false, false, requiredNamespaces, [])
            .then((accounts) => {
            (0, utils_1.logDebug)("inject-connector restoreconnect --accounts:", JSON.stringify(accounts));
            //compare account with sessionInfo
            let allEqual = true;
            for (let namespacesKey in sessionInfo.namespaces) {
                var accountsItem = accounts.find((item) => item.namespace === namespacesKey);
                var sessionAccounts = sessionInfo.namespaces[namespacesKey].accounts;
                if (!accountsItem) {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR, "resotreconnect error: accountItem error");
                }
                let newSessionAccounts = sessionAccounts;
                if (namespacesKey === protocol_1.NameSpaceKeyAptos && newSessionAccounts && newSessionAccounts.length > 0) {
                    newSessionAccounts = sessionAccounts.map((address) => {
                        return (0, utils_2.replaceChainNameToChainId)(address);
                    });
                }
                const areEqual = accountsItem.addresses.length === newSessionAccounts.length &&
                    accountsItem.addresses.slice().sort().every((value, index) => {
                        if (namespacesKey === protocol_1.NameSpaceKeyAptos) {
                            let aptosAdd = newSessionAccounts.slice().sort()[index];
                            (0, utils_1.logDebug)("check aptos address -value and aptosAdd--", value, aptosAdd);
                            return aptosAdd === value;
                        }
                        else {
                            return value === newSessionAccounts.slice().sort()[index];
                        }
                    });
                if (!areEqual) {
                    allEqual = false;
                }
            }
            if (allEqual) {
                onConnectResult(sessionInfo);
            }
            else {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.BAD_REQUEST_ERROR, "resotreconnect error: address not as same as session");
            }
        }).catch((e) => {
            (0, utils_1.logDebug)("inject-connector restoreconnect catch error", JSON.stringify(e));
            onConnectResult(null);
        });
    }
    getAccountByRequestWallets(needPop, isAccountChange, signalChain, requiredNamespaces, optionalNamespaces) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                var walletInfo = [];
                var accountResult = [];
                if ((0, media_1.isDevice)("mobile")) {
                    var walletInfoItem = yield window.okxwallet.connectWallet(needPop, {
                        requiredNamespaces: requiredNamespaces,
                        optionalNamespaces: optionalNamespaces
                    });
                    walletInfo.push(walletInfoItem);
                }
                else {
                    walletInfo = (yield window.okxwallet.requestWallets(needPop));
                }
                var allNameSpace = [...(requiredNamespaces !== null && requiredNamespaces !== void 0 ? requiredNamespaces : []), ...(optionalNamespaces !== null && optionalNamespaces !== void 0 ? optionalNamespaces : [])];
                let walletInfoFirst = walletInfo[0];
                (0, utils_1.logDebug)(" InjectEngine connect connectAccounts:", JSON.stringify(walletInfoFirst));
                let eventkey;
                let hasTON = false;
                if (allNameSpace && walletInfoFirst && walletInfoFirst.address) {
                    for (const [mapKey, provider] of this.providerMap.entries()) {
                        let itemResult = yield provider.parseConnectResponse(needPop, isAccountChange, signalChain, allNameSpace, walletInfoFirst, this.dappInfo);
                        if (itemResult) {
                            eventkey = mapKey;
                            accountResult.push(itemResult);
                            if (mapKey === protocol_1.NameSpaceKeyTON) {
                                hasTON = true;
                            }
                        }
                    }
                }
                // check require
                let cheeckRequire = requiredNamespaces.every(requireItem => {
                    // requireItem.namespace
                    let resultSel = accountResult.find(resultItem => {
                        return resultItem.namespace === requireItem.namespace;
                    });
                    if (resultSel) {
                        let hasChainAdd = requireItem.chains.every(chain => {
                            let addItem = resultSel.addresses.find(address => {
                                return address.startsWith(chain + ":");
                            });
                            return !!addItem;
                        });
                        return hasChainAdd;
                    }
                    return false;
                });
                (0, utils_1.logDebug)("InjectEngine connect requiredNamespaces:", JSON.stringify(requiredNamespaces));
                (0, utils_1.logDebug)("InjectEngine connect accountResult:", JSON.stringify(accountResult));
                if (!cheeckRequire) {
                    yield this.disconnect();
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.CHAIN_NOT_SUPPORTED);
                }
                if (!(0, media_1.isDevice)("mobile")) {
                    this.configEventWithKey(eventkey, hasTON);
                    yield window.okxwallet.requestWallets(needPop);
                }
                return accountResult;
            }
            catch (e) {
                if (e && typeof e === "object" && "code" in e) {
                    if (e.code === 4001) {
                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.USER_REJECTS_ERROR);
                    }
                }
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
            }
        });
    }
    configEventWithKey(key, hasTON) {
        if (window.okxwallet && key) {
            if (this.accountChangedEVMHandler) {
                window.okxwallet.removeListener('accountsChanged', this.accountChangedEVMHandler);
            }
            if (this.accountChangedSolanaPublicKeyHandler) {
                window.okxwallet.solana.removeListener('accountChanged', this.accountChangedSolanaPublicKeyHandler);
                window.okxwallet.sui.removeListener('accountChanged', this.accountChangedSolanaPublicKeyHandler);
            }
            if (this.accountChangedTONHandler) {
                window.okxTonWallet.tonconnect.off('accountChanged', this.accountChangedTONHandler);
            }
            if (hasTON) {
                console.log("window.okxwallet configEventWithKey:", key);
                this.accountChangedTONHandler = () => {
                    console.log("window.okxwallet configEventWithKey_TON:", Date.now(), key);
                    this.checkAccountChanged().catch(e => {
                        console.log("window.okxwallet configEventWithKey error: ", e);
                    });
                };
                window.okxTonWallet.tonconnect.on('accountChanged', this.accountChangedTONHandler);
            }
            else {
                switch (key) {
                    case protocol_1.NameSpaceKeyEip155:
                        {
                            console.log("window.okxwallet configEventWithKey:", key);
                            this.accountChangedEVMHandler = (accounts) => {
                                console.log("window.okxwallet configEventWithKey_evm:", Date.now(), key, accounts);
                                if (accounts && accounts.length > 0) { //
                                    this.checkAccountChanged().catch(e => {
                                        console.log("window.okxwallet configEventWithKey error: ", e);
                                    });
                                }
                            };
                            window.okxwallet.on('accountsChanged', this.accountChangedEVMHandler);
                        }
                        break;
                    case protocol_1.NameSpaceKeySOL:
                        {
                            console.log("window.okxwallet configEventWithKey:", key);
                            this.accountChangedSolanaPublicKeyHandler = (publicKey) => {
                                console.log("window.okxwallet configEventWithKey_solana:", Date.now(), key, publicKey);
                                if (publicKey) {
                                    this.checkAccountChanged().catch(e => {
                                        console.log("window.okxwallet configEventWithKey error: ", e);
                                    });
                                }
                            };
                            window.okxwallet.solana.on('accountChanged', this.accountChangedSolanaPublicKeyHandler);
                        }
                        break;
                    case protocol_1.NameSpaceKeySui:
                        {
                            console.log("window.okxwallet configEventWithKey:", key);
                            this.accountChangedSolanaPublicKeyHandler = (publicKey) => {
                                console.log("window.okxwallet configEventWithKey_sui:", Date.now(), key, publicKey);
                                if (publicKey) {
                                    this.checkAccountChanged().catch(e => {
                                        console.log("window.okxwallet configEventWithKey error: ", e);
                                    });
                                }
                            };
                            window.okxwallet.sui.on('accountChanged', this.accountChangedSolanaPublicKeyHandler);
                        }
                        break;
                    case protocol_1.NameSpaceKeyTON:
                        {
                            console.log("window.okxwallet configEventWithKey:", key);
                        }
                        break;
                    case protocol_1.NameSpaceKeyAptos:
                        {
                            window.okxwallet.aptos.onAccountChange((newAccount) => {
                                console.log("window.okxwallet configEventWithKey_aptos:", Date.now(), key, JSON.stringify(newAccount));
                                if (newAccount) {
                                    this.checkAccountChanged().catch(e => {
                                        console.log("window.okxwallet configEventWithKey error: ", e);
                                    });
                                }
                            });
                        }
                        break;
                    default:
                        break;
                }
            }
        }
    }
}
exports.InjectConnector = InjectConnector;
